import * as React from 'react';
import { PanelDefaultValues } from './panel-default-values';
import { ComplexValue } from 'ui/common/types';
import { sfNames, sfParameters } from 'app/components/access-panel/sf-names';
import { PanelsProps } from 'app/components/access-panel/types';
import { UserDefaultValues } from 'app/components/access-panel/shared/types';
import { ApiToUse } from 'app/infrastructure/simple-form/types';
import { FieldsOptionParams } from 'app/components/access-panel/default-values/types';

export interface DefaultValuesProps extends PanelsProps<UserDefaultValues> {
  apiToUse: ApiToUse;
  userType?: number;
  selectedUserType?: number;
  isUserTypeRequired: boolean;
  isValueFieldsReadOnly?: (optionsColection: ComplexValue<number>, caseType: ComplexValue<number>, userType?: number) => boolean;
  fieldsOptionParams?: FieldsOptionParams;
}

export const DefaultValues = (props: DefaultValuesProps) => {
  const { apiToUse, endpoints, readOnly, data, userType, isUserTypeRequired, clearValueInStore, clearValidation,
    formValues, formComponent, isValueFieldsReadOnly, validation, translation, simpleForm, formOptions,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, displaySelectAll, fieldsOptionParams } = props;

  return <PanelDefaultValues
    readOnly={readOnly}
    translation={translation}

    roleSelected={roleSelected}
    roleValue={roleBasedData && roleBasedData.defaultValues}
    accessData={accessData && accessData.defaultValues}
    updateAccessData={updateAccessData}
    fetchingRoleValue={fetchingRoleBasedData}

    formName={sfNames.defaultValues}
    formValues={formValues}
    formComponent={formComponent}
    valueName={sfParameters.field}
    initialValue={data && data.defaultValues}
    clearValidation={clearValidation}
    isValueFieldsReadOnly={isValueFieldsReadOnly}
    clearValueInStore={clearValueInStore}
    displaySelectAll={displaySelectAll}
    userType={userType}
    isUserTypeRequired={isUserTypeRequired}
    endpoints={endpoints}
    apiToUse={apiToUse}
    validation={validation}
    simpleForm={simpleForm}
    formOptions={formOptions}
    fieldsOptionParams={fieldsOptionParams}
  />;
};
